import formModel from './formModel';
import moment from "moment";

const {
    formField: {
        tamanioVivienda,
        tipoVivienda,
        codigosLocalidad,
        descuentoEspecial,
        afinidad,
        coberturasAdicionales: {
            sumaAsegurada,
            numeroCobertura,
            selectedCobertura
        },
        fechaCotizacion
    }
} = formModel;

export default {
    [tamanioVivienda.name]: "Chica",
    [tipoVivienda.name]: "1022",
    [codigosLocalidad.name]: "",
    [descuentoEspecial.name]: 20,
    [afinidad.name]: '',
    coberturasAdicionales: [
        {
            [sumaAsegurada.name]: 0,
            [numeroCobertura.name]: "26",
            [selectedCobertura.name]: false,
        },
        {
            [sumaAsegurada.name]: 0,
            [numeroCobertura.name]: "36",
            [selectedCobertura.name]: false,
        },
        {
            [sumaAsegurada.name]: 0,
            [numeroCobertura.name]: "37",
            [selectedCobertura.name]: false,
        },
        {
            [sumaAsegurada.name]: 0,
            [numeroCobertura.name]: "48",
            [selectedCobertura.name]: false,
        },
        {
            [sumaAsegurada.name]: 0,
            [numeroCobertura.name]: "49",
            [selectedCobertura.name]: false,
        },
    ],
    [fechaCotizacion.name]: moment().format('YYYY-MM-DD'),
};
